import React, { PropsWithChildren } from "react";
import { ErrorBoundary as BaseErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallback } from "@secondcloset/web-components";

export const ErrorBoundary: React.FC<PropsWithChildren<React.ReactNode>> = (props) => (
  <BaseErrorBoundary
    fallbackRender={({ error, resetErrorBoundary }) => (
      <ErrorBoundaryFallback error={error} eventId={error.message} resetError={resetErrorBoundary} />
    )}
  >
    {props.children}
  </BaseErrorBoundary>
);
